module.exports = __webpack_public_path__ + "fe6137a609da0909dc5c35483aadb04b.png";